const DURATION = 1000;
const INTERVAL = 32;
const dataElms = document.querySelectorAll('.num, .smallNum, .circleChart');
const formatter = new Intl.NumberFormat();

const countUp = (el) => {
	const from = parseInt(el.dataset.from);
	const to = parseInt(el.dataset.to);
	const startTime = Date.now();

	const timer = setInterval(() => {
		const elapsedTime = Date.now() - startTime;
		const progress = elapsedTime / DURATION;

		if (progress < 1) {
			if (el.dataset.type === 'countUp') {
				el.textContent = formatter.format(Math.floor(from + progress * (to - from)));
			} else if(el.dataset.type === 'countRand') {
				el.textContent = formatter.format(Math.floor(Math.random() * (to - from)) + from);
			}
		} else {
			el.textContent = formatter.format(to);
			clearInterval(timer);
		}
	}, INTERVAL);
};

window.addEventListener('scroll', () => {
	dataElms.forEach(el => {
		if (
			!el.classList.contains('on') &&
			el.getBoundingClientRect().top < window.innerHeight * 0.8
		) {
			if(el.dataset.type === 'countUp' || el.dataset.type === 'countRand') {
				countUp(el);
			}
			el.classList.add('on');
		}
	});
});
